var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.periods)?_c('span',_vm._l(([0,3]),function(sem){return _c('div',{key:sem},_vm._l(([1,2,3]),function(per){return _c('span',{key:per,class:{ active: _vm.allPeriods.includes(sem + per) }})}),0)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }